import React from "react";
import {
  Box,
  Grid,
  Typography,
  TextField,
  Button,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import { Twitter, Facebook, Instagram, LinkedIn } from "@mui/icons-material";
import styles from "./Footer.module.css";

const Footer = () => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const footerContent = [
    {
      title: "Features",
      items: [
        "AI Image Generator",
        "AI Background Remover", // New
        "AI Background Changer", // New
        "AI Image Enhancer", // New
        "AI Super Resolution", // New
        "AI Face Wrap", // New
        "AI Selfie Generator", // New
      ],
    },
    {
      title: "Tools",
      items: ["Text to Image", "Creative Enhance", "AI Video", "Image Remix"],
    },
    {
      title: "Company",
      items: ["API", "Affiliate Program", "Contact Us", "Careers"],
    },
    {
      title: "Legal",
      items: ["Privacy Policy", "Terms & Conditions"],
    },
    {
      title: "Remini",
      items: ["Blogs", "Community", "Our Tools", "Mobile App"],
    },
  ];

  return (
    <Box component="footer" className={styles.footerContainer}>
      <Grid container spacing={{ xs: 2, md: 6 }} className={styles.footerMain}>
        <Grid item xs={12} md={4} className={styles.newsletterSection}>
          <Typography variant="h6" className={styles.footerHeading}>
            Stay Updated
          </Typography>
          <Typography variant="body2" className={styles.newsletterText}>
            Subscribe to our newsletter for the latest creative trends and
            updates
          </Typography>
          <Box className={styles.newsletterForm}>
            <TextField
              variant="outlined"
              placeholder="Enter your email"
              size="small"
              fullWidth
              InputProps={{
                className: styles.newsletterInput,
              }}
            />
            <Button
              variant="contained"
              className={styles.subscribeButton}
              sx={{
                ml: { md: 0 },
                mt: { xs: 2, md: 0 },
                width: { xs: "100%", md: "auto" },
              }}
            >
              Subscribe
            </Button>
          </Box>
          <Box className={styles.socialIcons}>
            <IconButton className={styles.socialButton}>
              <Twitter className={styles.icon} />
            </IconButton>
            <IconButton className={styles.socialButton}>
              <Facebook className={styles.icon} />
            </IconButton>
            <IconButton className={styles.socialButton}>
              <Instagram className={styles.icon} />
            </IconButton>
            <IconButton className={styles.socialButton}>
              <LinkedIn className={styles.icon} />
            </IconButton>
          </Box>
        </Grid>

        {footerContent.map((section, index) => (
          <Grid
            item
            xs={6}
            sm={4}
            md={2}
            key={index}
            className={styles.linkSection}
          >
            <Typography variant="h6" className={styles.footerHeading}>
              {section.title}
            </Typography>
            <ul className={styles.footerList}>
              {section.items.map((item, itemIndex) => {
                const pathMap = {
                  "AI Image Generator": "/ai-image-generator",
                  "AI Background Remover": "/ai-background-remover",
                  "AI Background Changer": "/ai-background-changer",
                  "AI Image Enhancer": "/ai-image-enhancer",
                  "AI Super Resolution": "/ai-super-resolution",
                  "AI Face Wrap": "/ai-face-wrap",
                  "AI Selfie Generator": "/ai-selfie-generator",
                  "AI Image Colorizer": "/ai-image-colorizer",
                  "AI Image Expand": "/ai-expand-images",
                  "Contact Us": "/contact-us",
                };

                return (
                  <li key={itemIndex}>
                    <a
                      href={pathMap[item] || "/"}
                      className={styles.footerLink}
                    >
                      {item}
                    </a>
                  </li>
                );
              })}
            </ul>
          </Grid>
        ))}
      </Grid>

      <Box className={styles.footerBottom}>
        <Typography variant="body2" className={styles.copyrightText}>
          © {new Date().getFullYear()} Remini. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
